import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import router from './router'
import App from './App.vue'
import './style.less'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import http from './utils/request'
import Vue3DraggableResizable from 'vue3-draggable-resizable'
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
import { printPlugin } from 'vue-print-next'

import VueBarcode from '@chenfengyuan/vue-barcode'
const app = createApp(App)

const pinia = createPinia()

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.component(VueBarcode.name, VueBarcode)
app.use(pinia)
app.use(router)
app.use(Vue3DraggableResizable)
app.use(printPlugin)
app.use(ElementPlus, {
  locale: zhCn
})

// 将 http 添加到全局属性，可以在组件中通过 this.$http 访问
app.config.globalProperties.$http = http

// 初始化用户信息（从 localStorage 恢复登录状态）
import { useUserStore } from './stores/user'
const userStore = useUserStore()
// 如果有 token，尝试恢复用户信息
import { getToken } from './utils/token'
if (getToken()) {
  userStore.restoreUserInfo()
}
import './router/beforeEach'

// 设置页面标题
const appTitle = import.meta.env.VITE_APP_TITLE || 'Vue 3 Project'
document.title = appTitle

// 开发环境打印环境信息
if (import.meta.env.VITE_APP_ENV === 'development') {
  console.log('📦 当前环境:', import.meta.env.VITE_APP_ENV)
  console.log('📝 应用标题:', appTitle)
  console.log('🌐 API 地址:', import.meta.env.VITE_API_BASE_URL || '/api')
  // console.log = () => {}
} else {
  console.log = () => {}
}
app.mount('#app')
